import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DisplayValuePipe } from './display-value.pipe';

@NgModule({
  declarations: [DisplayValuePipe],
  imports: [CommonModule],
  exports: [DisplayValuePipe],
})
export class DisplayValueModule {}
